import { useMemo } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Select } from '@factorialco/f0-react'
import { TeamsSelectorDocument, TeamsSelectorQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export interface Team {
  id: string
  name: string
}

interface TeamSelectorProps {
  value?: Team | null
  onSelect: (team: Team | null) => void
  label?: string
  emptyLabel?: string
  mandatory?: boolean
  disabled?: boolean
  error?: boolean
}

export const TeamSelector = ({
  value,
  onSelect,
  label,
  emptyLabel,
  mandatory = false,
  disabled = false,
  error = false,
}: TeamSelectorProps) => {
  const { data: teamsData } = useQuery<TeamsSelectorQuery, Record<string, never>>(
    TeamsSelectorDocument
  )

  const options = useMemo(
    () =>
      (teamsData?.teams?.teamsConnection?.nodes || []).map(
        (node: TeamsSelectorQuery['teams']['teamsConnection']['nodes'][0]) => ({
          label: node?.name || '',
          value: String(node?.id || ''),
          avatar: {
            type: 'team' as const,
            name: node?.name || '',
            src: '',
          },
        })
      ),
    [teamsData]
  )

  const handleChange = (teamId: string) => {
    const team = teamsData?.teams?.teamsConnection?.nodes?.find(
      (node: TeamsSelectorQuery['teams']['teamsConnection']['nodes'][0]) =>
        String(node?.id) === teamId
    )
    onSelect(
      team
        ? {
            id: String(team.id),
            name: team.name || '',
          }
        : null
    )
  }

  return (
    <Box gap="s8">
      <F0Select
        label={label}
        value={value?.id}
        onChange={handleChange}
        options={options}
        placeholder={emptyLabel}
        size="md"
        searchable
        showSearchBox
        disabled={disabled}
        error={error}
        required={mandatory}
      />
    </Box>
  )
}
